<clr-modal
  [clrModalOpen]="isModalOpen()"
  (clrModalOpenChange)="isModalOpen.set($event)"
  [clrModalClosable]="true"
  [clrModalSize]="'xl'">
  <h3 class="modal-title">
    {{ 'Tabelle verwalten' | mrTranslate }}
    @if (route().title; as title) {
      : {{ title }}
    }
  </h3>
  <div class="modal-body d-f col gap-5" style="height: 70vh">
    <div class="d-f col width100 clr-flex-md-row clr-align-items-stretch clr-align-items-md-center gap-10 w-100-p">
      <div class="btn-group btn-icon">
        <button class="btn" (click)="selectedRow.set(null); form.reset()">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="file" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
              {{ 'Neuen Eintrag hinzufügen' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>
        @if (!isRep) {
          <button class="btn btn-danger" [disabled]="!selectedRow()" (click)="deleteRow()">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="times" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                {{ 'den Eintrag löschen' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
        }
      </div>

      <form clrForm class="nm flex-1-10-auto width100" (ngSubmit)="onSubmit()">
        <clr-input-container class="nm">
          <label class="clr-required-mark">{{ 'Bezeichnung' | mrTranslate }}</label>
          <input clrInput type="text" [formControl]="form.controls.Bezeichnung" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
        </clr-input-container>
      </form>
      <div class="btn-group btn-success nxm">
        <button (click)="onSubmit()" class="btn btn-sm" [clrLoading]="loadState()">
          {{ (selectedRow() ? 'Speichern' : 'Erstellen') | mrTranslate }}
        </button>
      </div>
    </div>

    <div class="flex-1-1-0 d-f row gap-25 w-100-p" style="min-height: 120px">
      @if (isLoading()) {
        <clr-spinner class="centred" />
      } @else if (table().columns.length) {
        <clr-datagrid
          class="datagrid-compact fill-space"
          [deselectButton]="true"
          [clrDgRowSelection]="true"
          [clrDgItemsIdentityFn]="row => row?.ID"
          [clrDgSelectionType]="'single'"
          [clrDgSelected]="[selectedRow()]"
          (clrDgSelectedChange)="selectedRow.set($event[0])">
          @for (column of table().columns; track column.id) {
            <clr-dg-column [clrDgField]="column.id">
              <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['skizze', 'profil'] }">
                {{ column.id | titlecase | mrTranslate }}
              </ng-container>
            </clr-dg-column>
          }
          <clr-dg-row *clrDgItems="let row of table().rows" [clrDgItem]="row">
            @for (cell of table().columns; track cell.id) {
              @if (cell.id == 'Typ') {
                <clr-dg-cell>
                  @switch (row.Typ) {
                    @case (TYPEN.Vignol) {
                      {{ 'Vignol' | mrTranslate }}
                    }
                    @case (TYPEN.Rille) {
                      {{ 'Rille' | mrTranslate }}
                    }
                  }
                </clr-dg-cell>
              } @else {
                <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
              }
            }
          </clr-dg-row>
          <clr-dg-footer>{{ table().rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
        </clr-datagrid>
      }
      <form
        id="baseitem-form"
        clrForm
        [formGroup]="form"
        (ngSubmit)="onSubmit()"
        class="width100 d-f col gap-10 scroll-y padding-12-lr"
        [clrLabelSize]="5"
        style="max-width: 500px">
        <clr-radio-container>
          <label>{{ 'Typ' | mrTranslate }}</label>
          <clr-radio-wrapper>
            <input type="radio" clrRadio [value]="TYPEN.Vignol" formControlName="Typ" />
            <label>{{ 'Vignolschiene' | mrTranslate }}</label>
          </clr-radio-wrapper>
          <clr-radio-wrapper>
            <input type="radio" clrRadio [value]="TYPEN.Rille" formControlName="Typ" />
            <label>{{ 'Rillenschiene' | mrTranslate }}</label>
          </clr-radio-wrapper>
        </clr-radio-container>
        <clr-number-input-container>
          <label class="clr-required-mark">
            {{ (form.value.Typ == TYPEN.Vignol ? 'Schienenhöhe' : 'Rillentiefe') | mrTranslate }}
          </label>
          <input type="number" clrNumberInput formControlName="Höhe" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
          @if (form.controls['Höhe'].errors?.min; as err) {
            <clr-control-error>{{ 'Mindestens' | mrTranslate }} {{ err.min }}</clr-control-error>
          }
        </clr-number-input-container>
        <clr-number-input-container>
          <label class="clr-required-mark">
            {{ 'Messebene' | mrTranslate }}
          </label>
          <input type="number" clrNumberInput formControlName="Messebene" />
          <clr-control-error *clrIfError="'required'">
            {{ 'Erforderlich' | mrTranslate }}
          </clr-control-error>
          @if (form.controls.Messebene.errors?.min; as err) {
            <clr-control-error>{{ 'Mindestens' | mrTranslate }} {{ err.min }}</clr-control-error>
          }
        </clr-number-input-container>

        <div class="flex-0-1-auto">
          <app-preview-thumbnails
            #skizze
            [title]="'Bild'"
            [showLabel]="true"
            [showCamera]="false"
            [acceptTypes]="'.png'"
            [maxAmount]="1"
            [isSkizze]="true"
            [skipSavedOnPack]="false" />
        </div>

        <div class="flex-0-1-auto">
          <div class="clr-form-control clr-row nxm">
            <span class="clr-control-label">{{ 'Profil' | mrTranslate }}</span>
          </div>
          @if (hasProfil()) {
            <button type="button" class="btn btn-icon btn-danger-outline" (click)="deleteProfil()">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="times" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                  {{ 'Profil löschen' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>
          } @else {
            <input type="file" hidden #fileInput [accept]="'.txt'" (change)="loadProfil($event)" />
            <button type="button" class="btn btn-icon" (click)="fileInput.click()">
              <clr-tooltip>
                <cds-icon clrTooltipTrigger shape="upload" />
                <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                  {{ 'Profil löschen' | mrTranslate }}
                </clr-tooltip-content>
              </clr-tooltip>
            </button>
          }
          <div #profil id="profilContainer" [class.empty]="!hasProfil()"></div>
          <button type="submit" hidden></button>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn" (click)="close()">
      {{ 'Schliessen' | mrTranslate }}
    </button>
  </div>
</clr-modal>
